import { URLS } from '../shared/url';
import { BaseHttpService } from './base-http.service';
import { ResponseTypeEnum } from '../models/enums';
import * as i0 from "@angular/core";
import * as i1 from "./base-http.service";
var CompanyService = /** @class */ (function () {
    function CompanyService(http) {
        var _this = this;
        this.http = http;
        this.getCompanyList = function () {
            return _this.http.Get(URLS.getCompanyList);
        };
        this.getCompany = function (id) {
            return _this.http.Get(URLS.getCompany + "/" + id);
        };
        this.saveCompany = function (company) {
            return _this.http.Post(URLS.saveCompany, company, ResponseTypeEnum.Success);
        };
        this.deleteCompany = function (companyId) {
            return _this.http.Delete(URLS.deleteCompany + "/" + companyId, ResponseTypeEnum.Success);
        };
    }
    CompanyService.ngInjectableDef = i0.defineInjectable({ factory: function CompanyService_Factory() { return new CompanyService(i0.inject(i1.BaseHttpService)); }, token: CompanyService, providedIn: "root" });
    return CompanyService;
}());
export { CompanyService };
